export class GChartLineStyle {
  color?: string;
  type?: 'dashed' | string;
  width?: number;

  constructor(init?: Readonly<GChartLineStyle>) {
    Object.assign(this, init);
  }
}
